import { Injectable } from '@angular/core';
import { urlServices } from './../../models/url.models';
import { HttpServiceService, } from 'src/app/common-service/http-service.service';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { encryptionService } from 'src/app/common-service/cedService';

@Injectable({
  providedIn: 'root'
})
export class ComplaintService {

  constructor(public http: HttpServiceService, public url: urlServices,public serverURL: ServerURLService,public ced: encryptionService) { }

  getRandomKeyGeneratorForGrivanceCompalints() {
    return this.http.get(this.url.getRandomKeyGeneratorForGrivanceCompalints);
  }

  downloaddoc(id: any) {
    return this.http.get<any>(this.url.documentUrl + '?uuid=' + id);
  }

  // Get Calls
  getAllCompalints(pageId: number, rows: number) {
    return this.http.get(this.url.allComplaints + '?userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId
      + '&page=' + pageId + '&rows=' + rows);
  }

  findAllComplaintTypes() {
    return this.http.get(this.url.getAllComplaintTypes);
  }

  getComplaintTypes(data:any) {
    return this.http.get(this.url.complaintTypes + '?againstId='+data);
  }

  getComplaintTypesByRoleAndAgainst(against: any) {
    const obj = { 
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),  
      complaintAgainst: this.ced.encryptAesToString(against, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getComplaintTypesByRoleAndAgainst, obj);
  }

  getComplaintAgainst() {
    return this.http.get(this.url.complaintAgainst);
  }

  viewComplaint(complaintId: any) {
    const obj = {
      complaintId : complaintId
    }
    return this.http.post(this.url.viewComp, obj);
   // return this.http.get(this.url.viewComp + 'complaintId=' + complaintId);
  }

  viewComplaintAddress(complaintId: any) {
    const obj = {
      complaintId : complaintId
    }
    return this.http.post(this.url.viewCompAddress,obj);
  //  return this.http.get(this.url.viewCompAddress + 'complaintId=' + complaintId);
  }

  colleageByState(collegeName: any) {
    return this.http.get(this.url.colleageByState + '?stateName=' + collegeName);
  }

  coleeageState() {
    return this.http.get(this.url.colleageState);
  }

  dentistData() {
    return this.http.get(this.url.dentistlist);
  }

  secById(sectionId: any) {
    return this.http.get(this.url.sectionById + '?sectionId=' + sectionId);
  }

  allSections() {
    return this.http.get(this.url.allSections);
  }

  serachValue(serach: any, page: any, rows: any) {
    const obj = {
      searchWord : serach,
      page : page,
      rows : rows,
      roleName : this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()  
    }
    return this.http.post(this.url.searchComplintsList,obj);
  }

  searchDentistList(stateId: any, dentistName: any, page: any, rows: any) {
    return this.http.get(this.url.searchDentistList + '?stateId=' + stateId
      + '&dentistName=' + dentistName + '&page=' + page + '&rows=' + rows);
  }

  // post Call
  raiseCompl(filearray: any, obj: any) {
    const roleName = this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString();
    const formdata = new FormData();
    formdata.append('complaintStr', JSON.stringify(obj));
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('files', filearray[i]);
    }
    // formdata.append('files', filearray);
   
    return this.http.post(this.url.raiseComp, formdata);
  }

  // reappeal Complaint 
  reappeal(obj: any, filearray: any) {
    const formdata = new FormData();
    formdata.append('complaintDtoStr', JSON.stringify(obj));
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('file', filearray[i]);
    }
    return this.http.post(this.url.reappeal, formdata);
  }

  //getAllComplaintListCount
  getAllComplaintListCount(){
    return this.http.get(this.url.getComplaintListCount);
  }

  //Dashboard 
  getComplaintList(complaintDashboardSearchCriteria: any ) {
    return this.http.post(this.url.getComplaintList, complaintDashboardSearchCriteria);
  }

  //Track Complaint
  getTrackComplaintList(complaintDashboardSearchCriteria: any ) {
    return this.http.post(this.url.getTrackComplaintList, complaintDashboardSearchCriteria);
  }

  //Raise New Complaint
  createNewComplaint(filearray: any, obj: any) {
    const roleName = this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString();
    const formdata = new FormData();
    formdata.append('complaintStr', JSON.stringify(obj));
    formdata.append('roleName', roleName);
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('files', filearray[i]);
    }   
    return this.http.post(this.url.createNewComplaint, formdata);
  }

  complaintAgainstByRole() {
    const roleNameEncr = encodeURIComponent(this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString());
    return this.http.get(this.url.complaintAgainstByRole + '?roleNameEncr=' + roleNameEncr);
  }

  getComplaintNoteSheetPurpose() {
    return this.http.get(this.url.getComplaintNoteSheetPurpose);
  }
  
  getAllComplaintStatus() {
    return this.http.get(this.url.findAllComplaintStatus);
  }

   // Reappeal Complaint 
   reAppealComplaint(obj: any, filearray: any) {
    const formdata = new FormData();
    formdata.append('complaintEnCryStr', JSON.stringify(obj));
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('file', filearray[i]);
    }
    return this.http.post(this.url.reAppealComplaint, formdata);
  }

  // Reappeal Complaint 
  complaintWorkflowWithDocument(obj: any, filearray: any) {
  const formdata = new FormData();
  formdata.append('complaintEnCryStr', JSON.stringify(obj));
  for (let i = 0; i < filearray.length; i++) {
    formdata.append('file', filearray[i]);
  }
  return this.http.post(this.url.complaintWorkflowWithDocument, formdata);
}

}
